/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserGroupFilters {
    getFixupPrototypeFunction() { return UserGroupFilters.fixupPrototype; }

    static newInstance(model: Partial<UserGroupFilters>): UserGroupFilters {
        let obj = Object.assign(new UserGroupFilters(), model);
        UserGroupFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserGroupFilters>): UserGroupFilters {
        if (!model) return null;
        return UserGroupFilters.newInstance(<UserGroupFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserGroupFilters) {
        if (!obj) return;

        models.UserGroupFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserGroupFilters): boolean {
        Object.setPrototypeOf(obj, UserGroupFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    tenant_ids: Array<string>;

    /**
     * Filter user groups that any of the given user IDs are a member of
     */
    user_ids: Array<string>;

}
